"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createFields = _interopRequireDefault(require("../createFields"));

var _immutable = _interopRequireDefault(require("../structure/immutable"));

var _default = (0, _createFields["default"])(_immutable["default"]);

exports["default"] = _default;